module.exports = __webpack_public_path__ + "img/back-in-the-swing-of-things.08e0aba4.svg";